<div *ngIf="isOpen" class="ion-page">
  <ion-header [translucent]="true" collapse="fade">
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button (click)="closeViewer()">
          <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>

      <ion-title>Immagine</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content [fullscreen]="true">
    <div
      class="zoom-container"
      (pinch)="onPinch($event)"
      (pinchend)="onPinchEnd()"
      (pan)="onPan($event)"
      (panend)="onPanEnd()"
      (doubletap)="onDoubleTap()"
    >
      <img
        [src]="imageSrc"
        alt="Immagine a tutto schermo"
        class="fullscreen-image"
        #image
      />
    </div>
  </ion-content>

  <ion-footer [translucent]="true" collapse="fade">
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button (click)="sharePhoto()" *ngIf="canShare()">
          <ion-icon slot="icon-only" name="share-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-footer>
</div>
